import React, { useEffect, useRef, useState } from "react";
import { Card, Typography, Button } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import subscriptionService from "../services/subscriptionService";

const { Title, Text } = Typography;

const SubscriptionSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isFinalizing, setIsFinalizing] = useState(true);
  const hasSyncedRef = useRef(false);

  useEffect(() => {
    if (hasSyncedRef.current) return;
    hasSyncedRef.current = true;

    const finalizeRegistration = async () => {
      try {
        const sessionId = searchParams.get("session_id");
        if (!sessionId) {
          throw new Error("Missing checkout session.");
        }
        await subscriptionService.completeRegistration(sessionId);
        localStorage.removeItem("authData");
        toast.success("Payment confirmed. Your account is now active.");
      } catch (error) {
        toast.error(
          error.response?.data?.error || error.message || "Payment verification failed. Please contact support."
        );
      } finally {
        setIsFinalizing(false);
      }
    };
    finalizeRegistration();
  }, [searchParams]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <Card className="w-full max-w-xl rounded-2xl shadow-md text-center">
        <Title level={3} className="!text-green-600 !mb-2">
          Payment Successful
        </Title>
        <Text className="block text-gray-600 mb-6">
          {isFinalizing
            ? "Finalizing your account..."
            : "Your account is active. You can now sign in."}
        </Text>
        <Button
          type="primary"
          size="large"
          className="bg-[#1e5782] hover:bg-[#184766]"
          onClick={() => navigate("/login")}
          disabled={isFinalizing}
        >
          Go to Login
        </Button>
      </Card>
    </div>
  );
};

export default SubscriptionSuccess;
